import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Flex, MenuLinkButton } from '@/components/common';
import { AccountSubpageShell } from '@/components/layout';

const LEGAL_EXTERNAL = [
  {
    to: '/privacy',
    titleKey: 'legal.privacy.title' as const,
    subtitleKey: 'legal.privacy.subtitle' as const,
  },
  {
    to: '/terms',
    titleKey: 'legal.terms.title' as const,
    subtitleKey: 'legal.terms.subtitle' as const,
  },
  {
    to: '/guidelines',
    titleKey: 'legal.guidelines.title' as const,
    subtitleKey: 'legal.guidelines.subtitle' as const,
  },
];

export function LegalSettingsPage() {
  const { t } = useTranslation('settings');
  const navigate = useNavigate();

  return (
    <AccountSubpageShell
      onBack={() => navigate('/account/help-legal')}
      title={t('legal.title')}
      subtitle={t('legal.subtitle')}
    >
      <Flex direction="column" gap="3">
        {LEGAL_EXTERNAL.map(({ to, titleKey, subtitleKey }) => (
          <MenuLinkButton key={to} to={to} external title={t(titleKey)} subtitle={t(subtitleKey)} />
        ))}

        <MenuLinkButton
          to="/account/settings/about/request-data"
          title={t('legal.requestData.title')}
          subtitle={t('legal.requestData.subtitle')}
        />
      </Flex>
    </AccountSubpageShell>
  );
}
